import { select, takeEvery, put } from 'redux-saga/effects'
import * as Sentry from '@sentry/browser'

// @ts-ignore
import { exportCSVOrganizationTrigger, fetchUsersForCSV } from 'store/entities/organizations/actions'

// @ts-ignore
import {
  getOrganizationUsersOrganizationId,
  getOrganizationUsersSortBy,
  getOrganizationUsersSortDesc,
  getOrganizationUsersFilterByTeam,
  getOrganizationUsersFilterBy,
  getOrganizationUsersTab,
  getOrganizationUsersFilter,
  getOrganizationUsersCount,
} from 'store/entities/organizations/selectors'
// @ts-ignore
import { FIRSTNAME, FULLNAME } from 'app/constants/organizations'

export default function* exportCSVUsersSaga() {
  yield takeEvery(exportCSVOrganizationTrigger, exportCSVFlow)
}

export function* exportCSVFlow() {
  const id = yield select(getOrganizationUsersOrganizationId)
  const sortBy = yield select(getOrganizationUsersSortBy)
  const sort = sortBy === FULLNAME ? FIRSTNAME : sortBy
  const desc = +(yield select(getOrganizationUsersSortDesc))
  const team = yield select(getOrganizationUsersFilterByTeam)
  const search = yield select(getOrganizationUsersFilterBy)
  // slice(0, -1) for delete plurals at tab name
  const role = (yield select(getOrganizationUsersTab)).slice(0, -1)
  const filterType = yield select(getOrganizationUsersFilter)
  const totalCount = yield select(getOrganizationUsersCount)

  const payload = {
    id,
    page: 0,
    limit: totalCount,
    sort,
    desc,
    team,
    search,
    role,
    filterType,
  }

  try {
    if (totalCount > 0) {
      yield put(fetchUsersForCSV(payload))
    }
  } catch (badResponse) {
    Sentry.withScope(scope => {
      scope.setExtra('error', badResponse)
      scope.setExtra('payload', JSON.stringify(payload))
      scope.setExtra('where error was happen', 'exportCSVUsersSaga')
      Sentry.captureException(badResponse)
    })
  }
}
